import type { LayoutElement } from '../types';

const ENTITY_NAME_PREFIX: Record<LayoutElement['type'], string> = {
  'overhead-rail': 'Rail',
  'overhead-curve': 'Rail Curve',
  'cross-rail': 'Junction',
  'oht-vehicle': 'OHT',
  stocker: 'Stocker',
  stb: 'STB',
  ohb: 'OHB',
  lifter: 'Lifter',
  'support-pillar': 'Pillar',
  'horizontal-beam': 'Beam',
  'suspension-rod': 'Rod',
  rectangle: 'Area',
  circle: 'Zone',
  text: 'Label',
};

function isUsableStoredName(name: string, elementId: string): boolean {
  const trimmed = name.trim();
  if (!trimmed) return false;
  if (trimmed === elementId) return false;
  return true;
}

/** User-facing label for a layout element (metadata.name, or Rail6-style fallback). */
export function resolveLayoutElementDisplayName(
  element: LayoutElement,
  elements: Record<string, LayoutElement>,
  elementOrder: string[]
): string {
  const storedName = element.metadata.name?.trim() ?? '';
  if (isUsableStoredName(storedName, element.id)) return storedName;

  const prefix = ENTITY_NAME_PREFIX[element.type] ?? 'Item';
  let index = 0;
  for (const id of elementOrder) {
    const candidate = elements[id];
    if (!candidate || candidate.type !== element.type) continue;
    index += 1;
    if (candidate.id === element.id) return `${prefix}${index}`;
  }
  return prefix;
}

/** Parse "rail-id" or "rail-id:2" into the owning layout element id. */
export function railIdFromSegmentId(segmentId: string): string {
  const colon = segmentId.lastIndexOf(':');
  if (colon === -1) return segmentId;
  const suffix = segmentId.slice(colon + 1);
  if (/^\d+$/.test(suffix)) return segmentId.slice(0, colon);
  return segmentId;
}
